import React from 'react';
import Grid from '@material-ui/core/Grid';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import * as utils from '../../../../helpers/utils';
import styles from './CannedMessagesList.module.css';
import { useRootStore } from '../../../../mobx/bridge';
import CannedMessage from '../CannedMessage/CannedMessage';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const CannedMessagesList = observer(function CannedMessagesList() {
  const { commonStore, cannedMessageStore, settingsStore } = useRootStore();
  const { t } = useTranslation();

  const settings = settingsStore.getLoggedUserSettings;

  const isSMSChannel =
    settings?.SelectedChannel?.ChannelType?.TypeId === utils.ChannelTypeEnum.SMS.TypeId;
  const isWebChatChannel =
    settings?.SelectedChannel?.ChannelType?.TypeId === utils.ChannelTypeEnum.WebChat.TypeId;

  const cannedMessages = cannedMessageStore.computedGetCannedMessagesForChannelType(
    settings?.SelectedChannel?.ChannelType?.TypeId
  );

  const toggleEditCannedMessages = () => {
    commonStore.setCannedMessagesListOpen(false);

    if (commonStore.mainComponentOpen) {
      commonStore.setMainComponentOpen(null);
    } else {
      commonStore.setMainComponentOpen(utils.mainComponentOpen.editCannedMessages);
    }
  };

  const closeCannedMessages = () => {
    commonStore.setCannedMessagesListOpen(false);
  };

  return (
    <Grid component="div" container>
      <Grid
        component="div"
        container
        item
        xs={12}
        justify="center"
        alignItems="center"
        className={styles.topBar}
      >
        <Grid component="div" item xs={9} align="left">
          <span className={styles.topBarHeader}>{t('CannedMessagesList.SelectCannedMessage')}</span>
        </Grid>

        <Grid component="div" item xs={2} align="center">
          <button
            type="button"
            className={styles.editCannedMessages}
            onClick={toggleEditCannedMessages}
            data-testid="editCannedMessages"
          />
        </Grid>

        <Grid component="div" item xs={1} align="center">
          <button
            type="button"
            className={styles.closeBtn}
            onClick={closeCannedMessages}
            data-testid="closeBtn"
          />
        </Grid>
      </Grid>

      <Grid component="div" item xs={12} className={styles.cannedMessagesContainer}>
        {cannedMessages.length === 0 ? (
          <Grid
            component="div"
            container
            item
            xs={12}
            alignItems="center"
            justify="center"
            className={styles.noCannedMessagesText}
          >
            {t('CannedMessagesList.NoCannedMessagesAvailable')}
          </Grid>
        ) : (
          cannedMessages.map((message) => (
            <Grid component="div" item xs={12} key={message._id}>
              <CannedMessage
                message={message}
                isSMSChannel={isSMSChannel}
                isWebChatChannel={isWebChatChannel}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
});
CannedMessagesList.whyDidYouRender = true;
CannedMessagesList.displayName = 'CannedMessagesList';

export default CannedMessagesList;
